import { Component, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';

import { TranslocoDirective } from '@jsverse/transloco';

import { ChrComponentsModule } from '@ciphr-design-system/angular';

import { AppBrandingService } from '@ciphr/core/app-branding';
import { NavigationStore } from '@ciphr/core/navigation';

import { PageHeaderService } from './page-header-service';

@Component({
  selector: 'ciphr-page-header',
  standalone: true,
  imports: [TranslocoDirective, ChrComponentsModule, RouterLink, NgTemplateOutlet],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  private readonly brandingService = inject(AppBrandingService);
  private readonly navigationStore = inject(NavigationStore, { optional: true });
  private readonly pageHeaderService = inject(PageHeaderService);

  readonly actionsTemplates = this.pageHeaderService.actionsTemplates;
  readonly logo = this.brandingService.brandingLogo;
  readonly menuButtonVisible = !!this.navigationStore;
  readonly titleTemplate = this.pageHeaderService.titleTemplate;

  showAppNavigation(): void {
    this.navigationStore?.toggleVisibility();
  }
}
